<template>
  <div class="effect-wrap">
    <div
      class="select-btn"
      @click="showOrder"
      v-if="pageType == 'create' || pageType == 'edit'"
    >
      选择订单
    </div>
    <upload-excel-component
      v-if="pageType == 'create' || pageType == 'edit'"
      :on-success="results => handleSuccess(results)"
      class="export-btn"
      >导入表格</upload-excel-component
    >
    <div
      class="select-btn"
      v-if="ids && ids.length > 0"
      @click="deleteAll"
      v-show="pageType == 'create' || pageType == 'edit'"
    >
      批量移除
    </div>
    <a
      style="cursor: pointer;color:#ff6224"
      v-if="pageType == 'create' || pageType == 'edit'"
      @click="
        handleExport(
          'https://triforce-esign.ruigushop.com/file/download/FS92f8260fb0844952bcb3eca3587993a2/template.xlsx'
        )
      "
      >下载导入模板</a
    >
    <div class="effect-order-wrap" v-if="ids && ids.length > 0">
      <div style="padding-top: 8px;">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%; text-align: center"
          size="mini"
          @select="handleSelection"
          @select-all="handleSelectAll"
          :row-key="row => row.id"
        >
          >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column prop="serial_number" label="编号" width="100" />
          <el-table-column prop="main_number" label="订单编号" />
          <el-table-column prop="created_at" label="推送日期" />
          <el-table-column prop="out_ware_day" label="要求发货日" />
          <el-table-column prop="total_amount" label="订单总金额" />
          <el-table-column prop="mo_status_str" label="订单状态" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                @click="deleteOne(scope.row.id)"
                style="color:#ff6224;cursor: pointer;"
                v-if="pageType == 'create' || pageType == 'edit'"
              >
                移除
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.page_size"
        layout="total,sizes, prev, pager, next,jumper"
        :total="queryInfo.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getOrderList, uploadOrder } from "@/models/orderReportModel";
import UploadExcelComponent from "@/components/common/UploadExcel/index.vue";
export default {
  props: ["ids", "pageType"],
  components: { UploadExcelComponent },
  data() {
    return {
      tableData: [], // 表格数据
      selectionRows: [],
      queryInfo: {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      },
      loading: false
    };
  },
  watch: {
    ids(val) {
      if (val) {
        this.getList(1, 10);
      }
    }
  },

  methods: {
    showOrder() {
      this.$emit("showOrder");
    },
    // 根据ids查询订单
    getList(page, page_size) {
      const params = {
        is_edit: 1,
        ids: this.ids,
        page: page || this.queryInfo.page || 1,
        page_size: page_size || this.queryInfo.page_size || 10
      };
      this.loading = true;
      getOrderList(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },

    // 改变pagesize
    handleSizeChange(value) {
      this.queryInfo.page_size = value;
      this.getList(this.queryInfo.page, value);
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.getList(value, this.queryInfo.page_size);
    },
    //
    handleSelection(val) {
      this.selectionRows = val;
    },
    handleSelectAll(val) {
      this.selectionRows = val;
    },
    deleteAll() {
      let selectIds = [];
      this.selectionRows.map(item => selectIds.push(item.id));
      this.delOrder(selectIds);
    },
    deleteOne(id) {
      this.delOrder([id]);
    },
    delOrder(selectIds) {
      let allIds = this.ids.split(",").map(Number);
      let index = -1;
      for (let i = 0; i < selectIds.length; i++) {
        index = allIds.indexOf(selectIds[i]);

        if (index > -1) {
          allIds.splice(index, 1);
        }
      }
      this.selectionRows = [];
      this.$emit("resetOrderIds", allIds);
    },
    // 导入excel
    async handleSuccess({ results, header }) {
      if (results.length > 0) {
        this.importFile(results, header);
      } else {
        this.$message.error("请填写数据");
      }
    },
    async importFile(results, header) {
      let priceArr = ["R0订单号"];
      if (this.filterAllLabel(header, priceArr)) {
        let data = results.map(item => {
          return {
            mainId: this.initImportData(item["R0订单号"])
          };
        });
        if (this.filterDuplicate(data)) {
          let vaild = data.every(item => {
            return item.mainId;
          });
          if (vaild) {
            let mainIds = [];
            data &&
              data.map(item => {
                mainIds.push(item.mainId);
              });
            const params = {
              shop_id: localStorage.getItem("shop_id"),
              main_numbers: mainIds.join(",")
            };
            this.uploadFile(params);
          } else {
            this.$message.error("R0订单号为空，请重新填写");
          }
        } else {
          this.$message.error("R0订单号重复，请重新填写");
        }
      } else {
        this.$message.error("请检查表头是否有误");
      }
    },
    uploadFile(params) {
      uploadOrder(params)
        .then(res => {
          this.loading = false;
          if (res && res.length > 0) {
            const ids = res; //需要一个数组
            this.$emit("exportOrder", ids);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },

    filterAllLabel(labels, template) {
      labels.sort();
      template.sort();
      let labelsT = JSON.stringify(labels);
      let templateT = JSON.stringify(template);
      if (labelsT === templateT) {
        return true;
      } else {
        return false;
      }
    },
    initImportData(value, fixed2) {
      if (typeof value === "number") {
        let num = new Number(value);
        if (fixed2) {
          return num.toFixed(2) + "";
        } else {
          return num + "";
        }
      }
      if (typeof value === "string") {
        return String(value + "").trim();
      }
      return "";
    },
    filterDuplicate(soure) {
      let arr = soure.map(item => {
        return item.mainId;
      });
      let filterArr = [...new Set(arr)];
      if (arr.length === filterArr.length) {
        return true;
      } else {
        return false;
      }
    },
    handleExport(url) {
      const getUrl = url.replace(/http:|https:/, "");
      window.open(getUrl);
    }
  }
};
</script>
<style lang="scss">
.effect-wrap {
  .export-btn {
    display: inline-block;
    margin-right: 8px;
    .el-button {
      background: #fff !important;
      color: #ff6224 !important;
    }
  }
  .effect-order-wrap {
    max-height: 320px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/reportCenter/components/effectOrderList.vue